import type { Namespace } from '../types';

// Maintenance ITSM (R-067/D-069). DE drafted — queued for review.
export const itsm = {
  title: { de: 'Maintenance', en: 'Maintenance' },
  desc: {
    de: 'Störungen mit SLA-Uhr, Changes mit Backout-Pflicht, Wartungspläne mit zweistufiger Freigabe und Wissensdatenbank.',
    en: 'Incidents with SLA clocks, changes with mandatory backout, maintenance plans with two-stage release, and the knowledge base.',
  },

  tabIncidents: { de: 'Störungen', en: 'Incidents' },
  tabChanges: { de: 'Changes', en: 'Changes' },
  tabPlans: { de: 'Wartungspläne', en: 'Plans' },
  tabKnowledge: { de: 'Wissen', en: 'Knowledge' },

  open: { de: 'Öffnen', en: 'Open' },
  notFound: { de: 'Datensatz nicht gefunden.', en: 'Record not found.' },

  // Incident statuses
  stNew: { de: 'Neu', en: 'New' },
  stInProgress: { de: 'In Arbeit', en: 'In progress' },
  stWaiting: { de: 'Wartend', en: 'Waiting' },
  stResolved: { de: 'Gelöst', en: 'Resolved' },
  stClosed: { de: 'Geschlossen', en: 'Closed' },

  // Stats
  statOpen: { de: 'Offen', en: 'Open' },
  statP1: { de: 'P1 offen', en: 'P1 open' },
  statBreached: { de: 'SLA verletzt', en: 'SLA breached' },
  statResolved: { de: 'Gelöst', en: 'Resolved' },

  // Incidents table
  colNumber: { de: 'Nummer', en: 'Number' },
  colTitle: { de: 'Titel', en: 'Title' },
  colPriority: { de: 'Priorität', en: 'Priority' },
  colStatus: { de: 'Status', en: 'Status' },
  colGroup: { de: 'Gruppe', en: 'Group' },
  colSlaDue: { de: 'SLA fällig', en: 'SLA due' },
  colCreated: { de: 'Erstellt', en: 'Created' },
  major: { de: 'Major', en: 'Major' },
  escalated: { de: 'Eskaliert', en: 'Escalated' },
  overdue: { de: 'Überfällig', en: 'Overdue' },
  filterAll: { de: 'Alle', en: 'All' },
  filterOpen: { de: 'Offen', en: 'Open' },
  searchIncidents: { de: 'Nummer oder Titel suchen…', en: 'Search number or title…' },
  incidentsEmpty: { de: 'Keine Störungen.', en: 'No incidents.' },

  // New incident
  newIncident: { de: 'Neue Störung', en: 'New incident' },
  incTitle: { de: 'Titel', en: 'Title' },
  incDescription: { de: 'Beschreibung', en: 'Description' },
  incPriority: { de: 'Priorität', en: 'Priority' },
  majorIncident: { de: 'Major Incident', en: 'Major incident' },
  majorHint: {
    de: 'P1 ist Major Incidents vorbehalten (INC-019).',
    en: 'P1 is reserved for major incidents (INC-019).',
  },
  roomCode: { de: 'Raum', en: 'Room' },
  group: { de: 'Zuständige Gruppe', en: 'Assignment group' },
  selectGroup: { de: 'Gruppe wählen…', en: 'Select group…' },
  create: { de: 'Anlegen', en: 'Create' },
  toastIncidentCreated: { de: '{number} angelegt.', en: '{number} created.' },

  // Record page
  reportedBy: { de: 'Gemeldet von', en: 'Reported by' },
  ackedBy: { de: 'Bestätigt von', en: 'Acknowledged by' },
  responseDue: { de: 'Reaktion fällig', en: 'Response due' },
  resolutionDue: { de: 'Lösung fällig', en: 'Resolution due' },
  respondedAt: { de: 'Reagiert am', en: 'Responded at' },
  resolvedAt: { de: 'Gelöst am', en: 'Resolved at' },
  closedAt: { de: 'Geschlossen am', en: 'Closed at' },
  asset: { de: 'Asset', en: 'Asset' },
  tabGeneral: { de: 'Allgemein', en: 'General' },
  tabWorkLog: { de: 'Arbeitsprotokoll', en: 'Work log' },
  ack: { de: 'Bestätigen', en: 'Acknowledge' },
  startWork: { de: 'Arbeit beginnen', en: 'Start work' },
  setWaiting: { de: 'Auf Wartend setzen', en: 'Set waiting' },
  resolve: { de: 'Lösen', en: 'Resolve' },
  close: { de: 'Schließen', en: 'Close' },
  assign: { de: 'Zuweisen', en: 'Assign' },
  swapSpare: { de: 'Ersatzteil tauschen', en: 'Swap spare' },
  toastAcked: { de: 'Störung bestätigt.', en: 'Incident acknowledged.' },
  toastTransitioned: { de: 'Status aktualisiert.', en: 'Status updated.' },
  toastAssigned: { de: 'Störung zugewiesen.', en: 'Incident assigned.' },
  toastSwapped: { de: 'Ersatzteil gebucht.', en: 'Spare part booked.' },

  // Resolve drawer (evidence — INC-006)
  resolveTitle: { de: '{number} lösen', en: 'Resolve {number}' },
  evidenceHint: {
    de: 'Ursache, Maßnahme und Abschlussnotiz sind Pflicht (INC-006).',
    en: 'Cause, action and resolution note are mandatory (INC-006).',
  },
  cause: { de: 'Ursache', en: 'Cause' },
  action: { de: 'Maßnahme', en: 'Action' },
  resolutionNote: { de: 'Abschlussnotiz', en: 'Resolution note' },

  // Swap drawer (INC-013)
  swapTitle: { de: 'Ersatzteil für {number}', en: 'Spare part for {number}' },
  swapHint: {
    de: 'Die Entnahme bucht FEFO aus dem Lager und protokolliert sie an der Störung.',
    en: 'The issue books FEFO from the warehouse and is logged on the incident.',
  },
  stockItem: { de: 'Artikel', en: 'Stock item' },
  selectItem: { de: 'Artikel wählen…', en: 'Select item…' },
  quantity: { de: 'Menge', en: 'Quantity' },
  note: { de: 'Notiz', en: 'Note' },

  // Comments / work log
  addComment: { de: 'Kommentar hinzufügen', en: 'Add comment' },
  commentPlaceholder: { de: 'Notiz zum Arbeitsprotokoll…', en: 'Note for the work log…' },
  noEvents: { de: 'Noch keine Einträge.', en: 'No entries yet.' },
  evCreated: { de: 'Angelegt', en: 'Created' },
  evStatus: { de: 'Statuswechsel', en: 'Status change' },
  evAssigned: { de: 'Zugewiesen', en: 'Assigned' },
  evAck: { de: 'Bestätigt', en: 'Acknowledged' },
  evComment: { de: 'Kommentar', en: 'Comment' },
  evSwap: { de: 'Ersatzteil getauscht', en: 'Spare swapped' },
  evEscalated: { de: 'SLA eskaliert', en: 'SLA escalated' },

  // Changes
  colType: { de: 'Typ', en: 'Type' },
  colApprover: { de: 'Genehmiger', en: 'Approver' },
  typeStandard: { de: 'Standard', en: 'Standard' },
  typeNormal: { de: 'Normal', en: 'Normal' },
  typeEmergency: { de: 'Notfall', en: 'Emergency' },
  chgDraft: { de: 'Entwurf', en: 'Draft' },
  chgSubmitted: { de: 'Eingereicht', en: 'Submitted' },
  chgApproved: { de: 'Genehmigt', en: 'Approved' },
  chgInImplementation: { de: 'In Umsetzung', en: 'In implementation' },
  chgReview: { de: 'In Prüfung', en: 'In review' },
  chgCompleted: { de: 'Abgeschlossen', en: 'Completed' },
  chgRejected: { de: 'Abgelehnt', en: 'Rejected' },
  changesEmpty: { de: 'Keine Changes.', en: 'No changes.' },
  newChange: { de: 'Neuer Change', en: 'New change' },
  justification: { de: 'Begründung', en: 'Justification' },
  risk: { de: 'Risiko', en: 'Risk' },
  backoutPlan: { de: 'Backout-Plan', en: 'Backout plan' },
  backoutHint: {
    de: 'Ohne Backout-Plan keine Einreichung (CHG-003).',
    en: 'No submission without a backout plan (CHG-003).',
  },
  emergencyHint: {
    de: 'Notfall-Changes werden sofort genehmigt und nachträglich protokolliert (CHG-002).',
    en: 'Emergency changes are approved immediately and logged post-hoc (CHG-002).',
  },
  submit: { de: 'Einreichen', en: 'Submit' },
  approve: { de: 'Genehmigen', en: 'Approve' },
  reject: { de: 'Ablehnen', en: 'Reject' },
  startImplementation: { de: 'Umsetzung starten', en: 'Start implementation' },
  toReview: { de: 'Zur Prüfung', en: 'To review' },
  complete: { de: 'Abschließen', en: 'Complete' },
  toastChangeCreated: { de: '{number} angelegt.', en: '{number} created.' },
  toastChangeUpdated: { de: 'Change aktualisiert.', en: 'Change updated.' },

  // Plans
  colWindow: { de: 'Zeitfenster', en: 'Window' },
  colImpact: { de: 'Auswirkung', en: 'Impact' },
  planPendingSupervisor: { de: 'Wartet: Supervisor', en: 'Pending supervisor' },
  planPendingCoo: { de: 'Wartet: COO', en: 'Pending COO' },
  planReleased: { de: 'Freigegeben', en: 'Released' },
  planInProgress: { de: 'In Arbeit', en: 'In progress' },
  planDone: { de: 'Erledigt', en: 'Done' },
  planCancelled: { de: 'Storniert', en: 'Cancelled' },
  plansEmpty: { de: 'Keine Wartungspläne.', en: 'No maintenance plans.' },
  newPlan: { de: 'Neuer Wartungsplan', en: 'New plan' },
  steps: { de: 'Arbeitsschritte', en: 'Work steps' },
  impact: { de: 'Auswirkung', en: 'Impact' },
  windowStart: { de: 'Fenster von', en: 'Window from' },
  windowEnd: { de: 'Fenster bis', en: 'Window until' },
  suppressionHint: {
    de: 'Im freigegebenen Zeitfenster werden Auto-Störungen für Asset/Raum unterdrückt (WART-004).',
    en: 'During the released window, auto-incidents for the asset/room are suppressed (WART-004).',
  },
  approveSupervisor: { de: 'Freigeben (Supervisor)', en: 'Approve (supervisor)' },
  approveCoo: { de: 'Freigeben (COO)', en: 'Approve (COO)' },
  start: { de: 'Starten', en: 'Start' },
  finish: { de: 'Abschließen', en: 'Finish' },
  cancel: { de: 'Stornieren', en: 'Cancel' },
  toastPlanCreated: { de: '{number} angelegt.', en: '{number} created.' },
  toastPlanUpdated: { de: 'Wartungsplan aktualisiert.', en: 'Plan updated.' },

  // Knowledge base
  colCategory: { de: 'Kategorie', en: 'Category' },
  colSkill: { de: 'Qualifikation', en: 'Skill' },
  colUpdated: { de: 'Aktualisiert', en: 'Updated' },
  confirmed: { de: 'Gelesen', en: 'Read' },
  confirmRead: { de: 'Als gelesen bestätigen', en: 'Confirm read' },
  kbEmpty: { de: 'Keine Artikel.', en: 'No articles.' },
  newArticle: { de: 'Neuer Artikel', en: 'New article' },
  editArticle: { de: 'Artikel bearbeiten', en: 'Edit article' },
  body: { de: 'Inhalt', en: 'Body' },
  safetyNotes: { de: 'Sicherheitshinweise', en: 'Safety notes' },
  category: { de: 'Kategorie', en: 'Category' },
  skill: { de: 'Qualifikation', en: 'Skill' },
  toastArticleSaved: { de: 'Artikel gespeichert.', en: 'Article saved.' },
  toastConfirmed: { de: 'Lesebestätigung erfasst.', en: 'Read confirmation recorded.' },
} as const satisfies Namespace;
